import { isRecord } from '../utils/is-record';
import { toAdminDroneFlightEntry } from '../utils/admin-spray-record-wire-utils';
import { listOf, nullableNumber, nullableString } from '../utils/wire-value-utils';
import { AdminDroneFlightEntry } from './admin-drone-flight-entry.model';
import { SprayRecord } from './spray-record.model';

/**
 * A spray record as `GET /admin/spray-records/:id` returns it (hub `SprayRecordService.getWithRelated`, the same
 * shape web reads). Adds what only the admin detail shows: the field's crop type and location, and each drone's
 * N-number. Read-only: the admin portal never writes spray records.
 */
export class AdminSprayRecord extends SprayRecord {
  declare droneFlights: AdminDroneFlightEntry[];

  // From the hub's nested `field` row (raw column names)
  cropType?: string | null;
  fieldLatitude?: number | null;
  fieldLongitude?: number | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    const field = isRecord(source['field']) ? source['field'] : {};
    this.droneFlights = listOf(source['droneFlights'], toAdminDroneFlightEntry);
    this.cropType = nullableString(field['crop_type']);
    this.fieldLatitude = nullableNumber(field['latitude']);
    this.fieldLongitude = nullableNumber(field['longitude']);
  }
}
